import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { UserState } from "../models/UserState";

const setErrorEmailVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.emailError = action.payload.error;
}

export default setErrorEmailVendor;